<template>
  <div class="profile-info">
    <div class="main has-text-white" :class="profileBoxStyle">
      <div class="basic-info columns" style="position: relative;">
        <div class="profile-pic column is-narrow">
          <div class="profile-pic-box">
            <div v-if="studentProfile.student.avatar && !avatarFailed">
              <img
                class="profile-avatar-img"
                :src="studentProfile.student.avatar"
                @error="disableAvatar"
              />
            </div>
            <div v-else>
              <male-avatar />
            </div>
          </div>
        </div>
        <div class="basic-info-content column">
          <p class="student-id fs-13">{{ studentProfile.student.code }}</p>
          <p class="student-firstname fs-20 is-uppercase">
            <a @click.prevent="navigateTo('app.profile')">{{ studentProfile.student.name }}</a>
          </p>
          <p class="student-program fs-13 is-capitalized">{{ formattedProgramLine }}</p>
        </div>

        <!-- EDIT BUTTON -->
        <a
          class="edit-btn"
          style="position: absolute; top: 0px; right: 10px"
          href="#"
          @click.prevent="navigateTo('app.profile.change_situation')"
        >
          <edit-icon style="width: 1.5em; height: 1.5em;" />
        </a>
      </div>
      <div class="risk-level-info">
        <span class="risk-level-indicator is-size-4 has-text-weight-bold">
          <span class="risk-level-indicator-arrow at-risk" style="visibility: hidden;">
            <arrow-icon />
          </span>
        </span>
        <span class="risk-level-value fs-26">{{
          studentProfile.student.desertionProbability | percentage
        }}</span>
        <span class="risk-level-description fs-13">{{ riskDescription }}</span>
      </div>
    </div>
    <div class="contact has-background-white">
      <div class="contact-basic">
        <h4 class="has-text-weight-medium is-marginless">CONTACTO</h4>
        <!-- PHONES -->
        <div v-for="(item, index) in studentProfile.student.phoneNumbers" class="contact-item">
          <span class="contact-item-icon" :class="{ invisible: index != 0 }">
            <telephone-icon />
          </span>
          <a class="contact-item-value" :href="callTo(item)">{{ item }}</a>
        </div>

        <div style="height: 7px;"></div>

        <!-- EMAILS -->
        <div v-for="(item, index) in studentProfile.student.emailAddresses" class="contact-item">
          <span class="contact-item-icon" :class="{ invisible: index != 0 }">
            <mail-icon />
          </span>
          <a class="contact-item-value" :href="mailTo(item)">{{ item }}</a>
        </div>
      </div>
      <div class="student-enrollment">
        <h4 class="has-text-weight-medium is-marginless">MATRÍCULA</h4>
        <p>{{ enrolledSinceText }}</p>
      </div>

      <div class="student-responsible">
        <h4 class="has-text-weight-medium is-marginless">RESPONSABLE</h4>
        <p>{{ responsibleName }}</p>
      </div>
    </div>
    <div class="more-info has-text-grey has-background-white fs-14">
      <a href="#" @click.prevent="navigateTo('app.profile.info')">+ Más información</a>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag"
import STUDENT_PROFILE from "./graphql/StudentProfile.gql"

import TelephoneIcon from "@/components/_base/TelephoneIcon.vue"
import MailIcon from "@/components/_base/MailIcon.vue"
import EditIcon from "@/components/_base/EditIcon.vue"
import ArrowIcon from "@/components/_base/ArrowIcon.vue"
import MaleAvatar from "@/components/_base/MaleAvatar.vue"

export default {
  name: "ProfileInfo",
  props: {
    studentId: {
      type: String
    }
  },
  apollo: {
    studentProfile: {
      query: STUDENT_PROFILE,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    }
  },
  data() {
    return {
      avatarFailed: false,
      studentProfile: {
        student: {
          responsible: {}
        }
      },
      riskDescription: "Riesgo de Deserción"
    }
  },
  computed: {
    responsibleName() {
      const responsible = this.studentProfile.student.responsible || {}
      return responsible.name || "-"
    },
    enrolledSinceText() {
      // State
      const currentState = this.studentProfile.student.currentState || {}
      const state = currentState.code || "-"
      // Since term
      const sinceTerm = this.studentProfile.student.enrolledSince
      const since = (sinceTerm && sinceTerm.name) || "?"
      // Join
      return `Desde ${since}, ${state}`
    },
    formattedProgramLine() {
      const enrollments = this.studentProfile.student.enrollments || []
      if (enrollments.length == 0) {
        return "-"
      }
      const e = enrollments[0]
      return [
        e.program.locationName,
        e.program.shiftName,
        e.program.deparmentName,
        e.program.name
      ].join(" | ")
    },
    profileBoxStyle() {
      const isAtRisk = this.studentProfile.activeAlerts > 0
      return {
        "has-background-danger": isAtRisk
      }
    }
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    callTo(phoneNumber) {
      return `tel:${phoneNumber}`
    },
    mailTo(emailAddress) {
      return `mailto:${emailAddress}`
    },
    disableAvatar() {
      this.avatarFailed = true

      // TODO
      // Send a mutation to the backend to clear the avatar url so we don't
      // load it again
    }
  },
  components: {
    TelephoneIcon,
    MailIcon,
    EditIcon,
    ArrowIcon,
    MaleAvatar
  },
  filters: {
    percentage(value) {
      if (value == null || Number.isNaN(value)) {
        return "-"
      }
      return (value * 100).toFixed(0) + "%"
    }
  }
}
</script>

<style scoped>
p {
  font-size: 14px;
}

.invisible {
  visibility: hidden;
}

.edit-btn {
  transition: all 0.35s ease;
  opacity: 0.5;
}

.edit-btn:hover {
  opacity: 1;
}

.profile-info .main {
  background-color: #bdbdbd;
}

.profile-pic.column,
.basic-info.column {
  padding-bottom: 0;
}
.profile-pic.column {
  padding-right: 0;
}

.profile-avatar-img {
  height: 100%;
  width: 100%;
  border-radius: 100%;
}

.risk-level-indicator-arrow {
  display: inline-block;
}
.risk-level-indicator-arrow.at-risk {
  transform: rotate(-45deg);
}

.risk-level-info {
  margin: -12px 0 2px 0;
}

.profile-info {
  position: relative;
}

.main {
  padding: 20px 10px 10px;
}

.basic-info {
  margin-bottom: 0 !important;
}

.basic-info-content p {
  margin: 0;
}

.basic-info-content .student-program {
  margin: 0.3rem 0;
}

.profile-pic {
  display: flex;
  justify-content: center;
}

.profile-edit {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 13px;
  margin-right: 17px;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  opacity: 0.5;
}

.profile-edit .icon {
  width: 22px;
  height: 22px;
}

.profile-pic-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
}

.fake-pic {
  display: inline-block;
  height: 80px;
  width: 80px;
  background: white;
  border-radius: 290486px;
}

/* CONTACT */
.contact {
  padding: 30px 20px;
  color: #333 !important;
  font-size: 14px !important;
}

.contact-item {
  margin: 7px 0;
}

.contact-item .contact-item-icon {
  width: 15px;
  display: inline-block;
  text-align: center;
}
.contact-item .contact-item-value {
  margin: 0 5px;
  color: #333;
  text-decoration: none;
}

.student-firstname a {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}

.student-enrollment,
.student-responsible {
  margin: 30px 0;
}
.student-responsible {
  margin-bottom: 0;
}

.student-enrollment p,
.student-responsible p {
  margin: 5px 0;
}

/* MORE INFO */
.more-info {
  margin-top: 2px;
  padding: 12px 20px;
}
.more-info a {
  color: #828282;
  text-decoration: none;
}
.more-info a:hover {
  text-decoration: underline;
}
</style>
